export default {
  common: {
    account: 'アカウント',
    myPage: 'マイページ',
    booking: '注文履歴',
    logout: 'ログアウト',
    save: '保存',
    colon: '：',
    multiply: '×',
    next: '次へ',
    return: '戻る',
    toPay: '支払いへ',
    update: '更新',
    search: '検索',
    space: ' ',
    add: '追加',
    confirm: '確認',
    cancel: 'キャンセル',
    searchPlaceholder: '検索...',
    tilde: '~',
    showMore: 'さらに表示'
  },
  price: {
    primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
    jpyWord: '円',
    jpySymbol: '¥'
  },
  footer: {
    terms: '利用規約',
    cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
    copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.'
  },
  validation: {
    required: '{{field}}は必須です',
    invalid: '有効な{{field}}を入力してください',
    password: '大文字、小文字、記号、数字を組み合わせた8文字以上で作成ください',
    imageType: '画像ファイルを選択してください',
    fileSize: '{{size}}MB以下のファイルを選択してください',
    range: '{{field}}は{{min}}から{{max}}の範囲で入力してください',
    requiredSelect: '{{field}}を選択してください',
    emailNotMatch: 'メールアドレスが一致しません',
    emailAlreadyRegistered:
      'このメールアドレスは既に登録されています。ログインボタンからログインしてください。'
  },
  firebase: {
    'auth/wrong-password': 'ログイン名またはパスワードが間違っています。',
    'auth/user-not-found': 'ログイン名またはパスワードが間違っています。',
    'auth/email-already-in-use': 'メールアドレスは既に登録されています。',
    'auth/too-many-requests':
      'ログイン試行の回数が上限を超えました。しばらくしてからもう一度お試しいただくか、パスワードをリセットしてください。'
  },
  apiErrors: {
    baseError: 'エラーが発生しました。',
    clientError: 'クライアントからのリクエストに誤りがありました。',
    serverError: 'サーバがリクエストの処理に失敗しました。',
    connectionError:
      '接続エラーが発生しました。通信環境をご確認して、再度お試しください。',
    requestError: 'リクエストの作成に誤りがありました。',
    ARSError: {
      AFFILIATE_ID_REQUIRED:
        'リクエスト失敗。会員限定ページのはじめからもう一度お試しください。',
      BOOKING_NOT_ENOUGH_ALLOTMENT:
        '選択された数量に対し在庫が不足しております。別の日時で再度お試しください。',
      BOOKING_NO_AVAILABILITY:
        '選択された数量に対し在庫が不足しております。別の日時で再度お試しください。',
      PERMISSION_DENIED: 'このリソースにアクセスする権限がありません。',
      NOT_FOUND: 'リソースが見つかりません。',
      BOOKING_ALREADY_ISSUED:
        '引換済・使用済のため、キャンセルはお受けできません。',
      BOOKING_RESERVATION_OVERLIMIT: '予約可能数を超えています。'
    }
  },
  login: {
    title: 'ログイン／新規登録',
    caption: 'ログイン、新規登録方法をお選びください。',
    appleLogin: 'Apple',
    googleLogin: 'Google',
    email: 'メールアドレス',
    emailConfirm: 'メールアドレス（確認）',
    password: 'パスワード',
    button: 'ログイン',
    forgotPassword: 'パスワードをお忘れの場合',
    newAccount: '新規登録',
    signInAgree: `※サードパーティアカウントをお持ちの方は簡単にログイン、会員登録できます。\n ※メールアドレスやサードパーティアカウントを使用して会員登録することにより <TermsLink>{{terms}}</TermsLink> および <PrivacyLink>{{privacy}}</PrivacyLink> に同意したものとみなされます。`
  },
  password: {
    changePassword: 'パスワード変更',
    resetPassword: 'パスワード再設定',
    sendResetEmail: 'パスワードリセットメールを送信する',
    sendResetEmailSuccess:
      'パスワード再設定用のURLが{{email}}に送信されます、ご確認のうえパスワードをリセットしてください。',
    oldPassword: '以前のパスワード',
    newPassword: '新しいパスワード',
    changePasswordSuccess: 'パスワードを変更しました。'
  },
  date: {
    sunday: '日曜日',
    monday: '月曜日',
    tuesday: '火曜日',
    wednesday: '水曜日',
    thursday: '木曜日',
    friday: '金曜日',
    saturday: '土曜日'
  },
  profile: {
    title: 'プロフィール',
    firstName: '名(半角英字を入力してください)',
    lastName: '姓(半角英字を入力してください)',
    email: 'メールアドレス',
    confirmEmail: 'メールアドレス（確認）',
    password: 'パスワード',
    gender: '性別',
    birthday: '生年月日',
    country: '国',
    prefecture: '都道府県',
    genderOptions: {
      male: '男',
      female: '女',
      other: 'その他'
    },
    updateProfileSuccess: 'プロフィールを更新しました',
    updateProfileFailed:
      'プロフィール更新に失敗しました, しばらくしてからもう一度お試しください'
  },
  weeks: {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土'
  },
  empty: {
    message: 'お探しの内容がありません'
  }
};
